import React from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";

export default class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      loginId : ''
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
  }

  componentDidMount(){
    var loginId = sessionStorage.getItem('loginId');
    this.setState({loginId : loginId});
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible
    });
  }

  logout(){
    console.log('Clicked on logout ');
    sessionStorage.clear();
  }

  render() {
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
    <span className="d-none d-md-inline-block">{this.state.loginId}</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={this.state.visible}>
          
          <DropdownItem divider />
          <DropdownItem tag={Link} to="/" onClick={(event) => this.logout()} className="text-danger">
            <i className="material-icons text-danger">&#xE879;</i> Logout
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}
